export const minutesToSeconds = (minutes: number | undefined): number | undefined => {
  if (minutes === undefined) {
    return undefined;
  }

  return minutes * 60;
};
